
import request from '@/utils/request';

/**
 * 用户产品列表
 * @param id
 * @constructor
 */
export function proListApi(params) {
  return request({
    url: `/front/user/proList`,
    method: 'get',
    params
  });
}
/**
 * 分类列表
 * @param id
 * @constructor
 */
export function categoryListApi(params) {
  return request({
    url: `/front/user/pro/category/list`,
    method: 'get',
    params
  });
}
/**
 * 产品详情
 * @param id
 * @constructor
 */
export function productInfoApi(params) {
  return request({
    url: `/front/user/info`,
    method: 'GET',
    params
  });
}
/**
 * 获取首页信息
 * @param id
 * @constructor
 */
export function indexFileApi() {
  return request({
    url: `/front/user/index/file/get/info`,
    method: 'get',
  });
}
/**
 * 新闻笔记列表
 * @param id
 * @constructor
 */
export function notesListApi(params) {
  return request({
    url: `/front/user/notes/list`,
    method: 'get',
    params
  });
}
/**
 * 公司简介
 * @param id
 * @constructor
 */
export function companyIntroApi() {
  return request({
    url: `/front/user/company/get/message`,
    method: 'get',
  });
}
/**
 * 笔记详情
 * @param id
 * @constructor
 */
export function notesDetailApi(params) {
  return request({
    url: `/front/user/notes/detail`,
    method: 'get',
    params
  });
}
/**
 * 产品推荐关键词列表
 * @param id
 * @constructor
 */
export function keywordListApi(params) {
  return request({
    url: `/front/user/keyword/list`,
    method: 'get',
    params
  });
}
/**
 * 资料打包下载
 * @param id
 * @constructor
 */
export function producttZipApi(params) {
  return request({
    url: `/front/download/zip`,
    method: 'get',
    params
  });
}
/**
 * 单个下载
 * @param id
 * @constructor
 */
export function producttSingleApi(params) {
  return request({
    url: `/front/download/single`,
    method: 'get',
    params
  });
}
/**
 * 产品资料图详情
 * @param id
 * @constructor
 */
export function producttImageApi(params) {
  return request({
    url: `/front/user/product/image/info`,
    method: 'get',
    params
  });
}
/**
 * 批量产品打包下载
 * @param id
 * @constructor
 */
export function downloadZipApi(data) {
  return request({
    url: `/front/download/batch/zip`,
    method: 'post',
    data
  });
}
/**
 * 父级分类列表
 * @param id
 * @constructor
 */
export function parentCategoryApi() {
  return request({
    url: `/front/user/parent/category/list`,
    method: 'GET',
  });
}